/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetSubscriptionConfig200Response
 */
export interface GetSubscriptionConfig200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetSubscriptionConfig200Response
     */
    allowPlanDowngrade: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSubscriptionConfig200Response
     */
    allowPlanUpgrade: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSubscriptionConfig200Response
     */
    reason?: string;
}

/**
 * Check if a given object implements the GetSubscriptionConfig200Response interface.
 */
export function instanceOfGetSubscriptionConfig200Response(value: object): value is GetSubscriptionConfig200Response {
    if (!('allowPlanDowngrade' in value) || value['allowPlanDowngrade'] === undefined) return false;
    if (!('allowPlanUpgrade' in value) || value['allowPlanUpgrade'] === undefined) return false;
    return true;
}

export function GetSubscriptionConfig200ResponseFromJSON(json: any): GetSubscriptionConfig200Response {
    return GetSubscriptionConfig200ResponseFromJSONTyped(json, false);
}

export function GetSubscriptionConfig200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSubscriptionConfig200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'allowPlanDowngrade': json['allowPlanDowngrade'],
        'allowPlanUpgrade': json['allowPlanUpgrade'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function GetSubscriptionConfig200ResponseToJSON(json: any): GetSubscriptionConfig200Response {
    return GetSubscriptionConfig200ResponseToJSONTyped(json, false);
}

export function GetSubscriptionConfig200ResponseToJSONTyped(value?: GetSubscriptionConfig200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'allowPlanDowngrade': value['allowPlanDowngrade'],
        'allowPlanUpgrade': value['allowPlanUpgrade'],
        'reason': value['reason'],
    };
}

